import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-social-media',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './social-media.html',
  styleUrl: './social-media.css'
})
export class SocialMediaComponent {
  features = [
    {
      icon: 'palette',
      title: 'Content Creation',
      description: 'Engaging visual and written content tailored to each platform and your target audience.'
    },
    {
      icon: 'calendar_today',
      title: 'Strategic Scheduling',
      description: 'Optimized posting schedules based on audience behavior and platform algorithms.'
    },
    {
      icon: 'people',
      title: 'Community Management',
      description: 'Active engagement with your audience, responding to comments and messages promptly.'
    },
    {
      icon: 'star',
      title: 'Influencer Marketing',
      description: 'Partnerships with relevant influencers to expand your reach and credibility.'
    },
    {
      icon: 'analytics',
      title: 'Performance Analytics',
      description: 'Comprehensive reporting on engagement, reach, conversions, and ROI metrics.'
    },
    {
      icon: 'campaign',
      title: 'Brand Voice Development',
      description: 'Consistent brand messaging and tone across all social media platforms.'
    }
  ];

  process = [
    {
      step: '01',
      title: 'Social Audit & Strategy',
      description: 'We analyze your current social presence, competitors, and audience to develop a comprehensive content strategy.'
    },
    {
      step: '02',
      title: 'Content Planning',
      description: 'Create a content calendar with diverse post types, themes, and campaigns aligned with your business goals.'
    },
    {
      step: '03',
      title: 'Creation & Engagement',
      description: 'Produce high-quality content, schedule posts, and actively engage with your community daily.'
    },
    {
      step: '04',
      title: 'Analyze & Optimize',
      description: 'Monitor performance metrics, gather insights, and continuously refine strategy for better results.'
    }
  ];

  caseStudy = {
    client: 'FreshBite Organic Foods',
    industry: 'Organic Food & Beverage',
    image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=800&h=500&fit=crop',
    challenge: 'FreshBite needed to build brand awareness and drive sales in a competitive organic food market. Their social media presence was minimal with low engagement and inconsistent posting.',
    solution: 'We developed a vibrant content strategy featuring recipe videos, behind-the-scenes farm tours, nutritional tips, and user-generated content campaigns. We leveraged Instagram and TikTok for visual storytelling and Facebook for community building.',
    results: [
      '285% increase in social media followers across all platforms',
      '420% boost in engagement rate with interactive content',
      '150% increase in website traffic from social channels',
      '95% growth in online sales attributed to social media campaigns'
    ]
  };

  testimonial = {
    quote: 'HoneyKode transformed our social media from a sporadic afterthought into our most powerful marketing channel. Their creative content and strategic approach helped us connect with our audience authentically and drive real business results.',
    author: 'Rachel Martinez',
    role: 'Marketing Director',
    company: 'FreshBite Organic Foods',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop'
  };
}
